import React from "react";
import { Helmet } from 'react-helmet';


function SupportOnline(){

return (

<div>

<Helmet>
        <title>سیستم یکپارچه مالی راینو - پشتیبانی آنلاین</title>
        <meta name="description" content="پشتیبانی آنلاین 24 ساعته برای کمک به شما در حل مشکلات." />
        <meta name="keywords" content="پشتیبانی, آنلاین, کمک , راینو" />
</Helmet>


<section className="py-4 bg-light title">

   <div className="container">
     <div className="row">
        <div className="col-md-4 my-auto">
        <h3 className="float-end"> پشتیبانی آنلاین </h3>
        </div>

      </div>
     </div>

</section>




<section className="section border-bottom">
  <div className="container">
  <h5 className="main-heading">شرکت فنی مهندسی پویارایانه فرتاک : سلام درخدمتم</h5>
  <div className="underline"></div>

  </div>

</section>


</div>


    )

}












export default SupportOnline;